import { FuzzySearch } from 'components/modules/foundation/services/search';
import { formatStyleRuleName } from 'components/modules/style-rules/services/format';

import { RESULTS_LIMIT } from './RawEditField.constants';

export function getAllResults(styleRuleName, styleRuleConfigurations) {
  return styleRuleConfigurations
    .filter(
      ({ name: currentName }) =>
        formatStyleRuleName(currentName) !== formatStyleRuleName(styleRuleName),
    )
    .map(({ name: currentName }) => ({
      key: currentName,
      title: formatStyleRuleName(currentName),
    }));
}

export function searchResults(results, searchQuery) {
  const fuzzySearch = new FuzzySearch(results, ['title']);
  return fuzzySearch.search(formatStyleRuleName(searchQuery)).slice(0, RESULTS_LIMIT);
}
